import type { RegraComissao } from '../db/tipos'

// Resumo da comissao no card da tabela (pedido dela, 28/09): "% por produto ·
// 1,50%" nao dizia nada. % fixo -> o numero; por produto -> a FAIXA do menor
// ao maior % que a tabela paga. O padrao so entra se algum produto cai nele.
const pct = (n: number) => `${n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`

export function textoComissaoDaTabela({ tipo, pctPadrao, explicitos, algumSemExplicito }: {
  tipo: RegraComissao['tipo']
  pctPadrao: number | null
  explicitos: readonly number[]
  algumSemExplicito: boolean
}): string {
  const valores = tipo === 'pct_fixo'
    ? (pctPadrao === null ? [] : [pctPadrao])
    : [...explicitos, ...(algumSemExplicito && pctPadrao !== null ? [pctPadrao] : [])]
  if (valores.length === 0) return 'Comissão —'
  const min = Math.min(...valores)
  const max = Math.max(...valores)
  return min === max ? `Comissão ${pct(min)}` : `Comissão ${pct(min)} a ${pct(max)}`
}
